import { constants } from "../constants/constants";



const {
  IP_INFO_TOKEN
} = constants();


//! resume forms API

export const RESUME_FORMS_API_ROUTES = {
  "RESUME": "/applicants",
};

//! IP Info

export const IP_INFO_API_ROUTES = {
  "IP_INFO": `https://ipinfo.io/json?token=${IP_INFO_TOKEN}`
}


//! Jobs

export const JOBS_API_ROUTES = {
  "JOBS": "/jobs"
}

//! Blogs

export const BLOGS_API_ROUTES = {
  "BLOGS": "/blogs",
  "BLOGS_SLUGS": "/blogs/slug"
}

//! Open Forum

export const OPEN_FORUM_API_ROUTES = {
  "RSVP": "/open-forum/rsvp",
  "EXPORT_CSV": "/open-forum/export-rsvp",
  "MARK_ATTENDANCE": "/open-forum/markAttendance"
}


//! Resume Clinic

export const RESUME_CLINIC_API_ROUTES = {
  "RSVP": "/resume/clinic",
  "EXPORT_CSV": "/resume-clinic/export-rsvp",
}

